import {ref} from 'vue';

export default {
    install: (app, options) => {
        const serviceCurrentPrice = ref(null);

        const loadServiceCurrentPrice = (urlParameters) => {
            const defaultUrlParameters = {
                service_key: '',
            };

            urlParameters = Object.assign(defaultUrlParameters, urlParameters)

            const urlSearchParams = new URLSearchParams(urlParameters);

            window.lazy_axios.get(`/dashboard/services/${urlParameters.service_key}/current-price`)
                .then((response) => {
                    if (response.data.current_price) {
                        serviceCurrentPrice.value = response.data.current_price;
                    }
                });
        };

        app.provide('serviceCurrentPrice', serviceCurrentPrice);
        app.provide('loadServiceCurrentPrice', loadServiceCurrentPrice);

        app.provide('serviceCurrentPriceProvider', {
            serviceCurrentPrice,
            loadServiceCurrentPrice,
        });
    },
}
